import { render, staticRenderFns } from "./sealTest.vue?vue&type=template&id=45ca1082&scoped=true"
import script from "./sealTest.vue?vue&type=script&lang=js"
export * from "./sealTest.vue?vue&type=script&lang=js"
import style0 from "./sealTest.vue?vue&type=style&index=0&id=45ca1082&prod&scoped=true&lang=css"
import style1 from "./sealTest.vue?vue&type=style&index=1&id=45ca1082&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca1082",
  null
  
)

export default component.exports